import { useCallback, FunctionComponent } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'redux/store'
import cx from 'classnames'
import Button from '@mui/material/Button'
import { URL_FREE_TRIAL, URL_SOLUTIONS } from 'constants/links'
import { pushEvent } from 'services/AnalyticsService'
import { setFreeTrialRequestModalIsOpen, setSignUpModalIsOpen } from 'redux/actions'

export const RequestFreeTrialButton: FunctionComponent<RequestFreeTrialButtonProps> = ({
  analyticsLabel,
  className = 'pv5 min-w14 f5 fw6 tracked-cosy',
  buttonText = 'Request a Free Trial'
}) => {
  const dispatch = useDispatch<AppDispatch>()

  const handleOnClick = useCallback(() => {
    pushEvent({ category: 'Free Trial', action: 'Open', label: analyticsLabel })
    dispatch(setSignUpModalIsOpen(false))
    dispatch(setFreeTrialRequestModalIsOpen(true))
  }, [analyticsLabel])

  return (
    <a href={URL_FREE_TRIAL} className='no-underline color-inherit pointer'>
      <Button
        onClick={handleOnClick}
        className={cx('ttn bg-light-sea-green-2 hover-bg-dark-sea-green-2 ba2 b--dark-cerulean hover-b--dark-sea-green-2 white', className)}
      >
        {buttonText}
      </Button>
    </a>
  )
}

export const SolutionsButton: FunctionComponent = () => (
  <a href={URL_SOLUTIONS} className='no-underline color-inherit pointer'>
    <Button className='ttn bg-white hover-bg-cadet-blue cadet-blue hover-white f5 fw6 tracked-cosy ba2 b--cadet-blue min-w14 pv5'>
      View Solutions
    </Button>
  </a>
)

interface RequestFreeTrialButtonProps {
  analyticsLabel: string
  className?: string
  buttonText?: string
  showSignUpModalOnFreeTrialModalClose: boolean
}
